import { createStore } from "common-frontend-components";
const { get, set, useStore, fetchStore } = createStore({ getDefaultValues: () => ({
        open: false,
        contactSent: false,
    }) });
export const sendContactInfoStore = {
    isOpen: () => get().open,
    openContact: () => set({ open: true }),
    closeContact: () => set({ open: false }),
    useOpen: () => useStore(fetchStore.open),
    setContactSent: () => set({ contactSent: true }),
    useContactSent: () => useStore(fetchStore.contactSent),
};
//# sourceMappingURL=sendContactInfoStore.js.map